/**
 * @generated SignedSource<<7792bd70fa6cae4b26791115290a9e40>>
 * @relayHash 1f900e3f76d39c698f7472da690b91b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 088128f3d447f3e089335ab35d09766d9c7bd3e8858ed9a614ff5799bfd5761b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardFilterRefinementQuery } from './boardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<boardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "088128f3d447f3e089335ab35d09766d9c7bd3e8858ed9a614ff5799bfd5761b",
    "metadata": {},
    "name": "boardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
